import * as React from 'react';

import { IValuesCollection } from '../../ts/appTheme';
import { themeVars } from '../../../../pdc-platform/src/ts/themes/themeConstants';
import { IDisplayValue } from '../../ts/Interfaces';
import { ISuggestionValue } from '../SuggestionListField';
import { REMOVE_CELL_WIDTH, RemoveItemButton } from './Buttons';

export type IGetElementComponent = (value: ISuggestionValue) => React.JSX.Element;

export const MIN_SELECTED_ITEM_WIDTH = 28;

const DEFAULT_LETTER_WIDTH = 12.8;
const MARGIN = 4;

export interface IItemToShow extends IDisplayValue {
    maxWidth: number;
}

export function normalizeTitle(title: any) {
    if (title == null) {
        return '';
    }

    return (typeof title === 'string' ? title : '' + title).replace(/ +/g, ' ').trim();
}

export function getSelectedItemWidth(fontWidth: number, title: string, showRemoveButton: boolean) {
    const oneLetterWidth = (fontWidth ?? DEFAULT_LETTER_WIDTH) / 2 + 2;

    let width = oneLetterWidth * title.length + MARGIN;

    if (showRemoveButton) {
        width += REMOVE_CELL_WIDTH;
    }

    return width;
}

export function getSelectedItemStyle(theme: IValuesCollection) {
    const result: React.CSSProperties = {};

    if (theme != null) {
        result.background = theme[themeVars.itemSelector_SelectedItemBackgroundColor] || 'lightgray';

        const foregroundColor = theme[themeVars.itemSelector_SelectedItemForegroundColor];

        if (foregroundColor != null) {
            result.color = foregroundColor;
        }
    }

    return result;
}

export function SelectedItem(props: {
    value?: IDisplayValue;
    title?: string;
    maxWidth: number;
    minWidth?: number;
    showRemoveButton?: boolean;
    limitedText?: boolean;

    getElementComponent?: IGetElementComponent;

    onClick?(e): void;
    onRemove?(value: IDisplayValue): void;
}) {
    let maxWidth = props.maxWidth - 8;
    let elementComponentCell: React.JSX.Element;
    let removeCell: React.JSX.Element;

    if (props.value != null && props.getElementComponent != null) {
        elementComponentCell = (
            <td className="value-element-component-cell">{props.getElementComponent(props.value)}</td>
        );
    }

    if (props.showRemoveButton) {
        maxWidth -= REMOVE_CELL_WIDTH;
        removeCell = (
            <RemoveItemButton
                onClick={() => {
                    props.onRemove?.(props.value);
                }}
            />
        );
    }

    let titleClass = 'value-title-cell';
    let titleStyle: React.CSSProperties;

    if (props.limitedText !== false && maxWidth > 0) {
        titleClass += ' limited-text';
        titleStyle = {
            maxWidth: maxWidth + 'px'
        };

        if (props.minWidth > 0) {
            titleStyle.minWidth = props.minWidth;
        }
    }

    return (
        <div className="value-element">
            <table className="table-borderless w-100 fit-content">
                <tbody>
                    <tr>
                        <td className={titleClass} style={titleStyle} onClick={props.onClick}>
                            {props.title ??
                                (props.value != null ? (props.value.displayValue ?? props.value.value) : '')}
                        </td>

                        {elementComponentCell}
                        {removeCell}
                    </tr>
                </tbody>
            </table>
        </div>
    );
}
